export enum SpecializationType {
    // Детское
    Children = 1,

    // Взрослое
    Adult = 2,

    // Травмпункт
    EmergencyRoom = 3,

    // Комбустиология
    Combustiology = 4,

    // Таксикология
    Toxicology = 5
}
